import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./olo_order_history_source.js";
//#region src/olo_order_history_source_helper.ts
var olo_order_history_source_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(source) {
	switch (source) {
		case "recent-products": return "Recent Products";
		case "recent-orders": return "Recent Orders";
	}
}
//#endregion
export { name, olo_order_history_source_helper_exports };

//# sourceMappingURL=olo_order_history_source_helper.js.map